var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top-content"},[_c('p',[_c('i',{staticClass:"weui-icon-success weui-icon_msg"}),_vm._v("支付成功")])])])}]

export { render, staticRenderFns }